//deps
import { ReviewedCart } from "@cart-client/interfaces/Cart";

//internal-deps
import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";

//helpers
import { isCartTotalZero } from "./CartItemRenderer";

export const isTurboPaymentEnabled = (cartResponse: ReviewedCart | null, isTurboPayWidgetHidden: boolean) => {
    const isAccessibilityEnabled =
        GlobalHeaderState.getHeader(SwgyHeaderKeysList.accessibilityEnabled) === "true" || false;

    return !isAccessibilityEnabled && !isTurboPayWidgetHidden && !isCartTotalZero(cartResponse);
};

export const isTurboPayDiscountValueEnabled = (cartResponse: ReviewedCart | null) => {
    return cartResponse?.data?.turbo_pay_discount_value_enabled ?? false;
};
